<template>
  <!--
    DsField — implementación Vue del component field del DS (components/field/field.css).
    La unidad operacional del formulario: label ↕ control ↕ helper/error. Composición,
    no átomo — el control (DsInput/DsSelect…) va en el slot y aporta su propio border/focus.
  -->
  <label class="ds-field">
    <span v-if="label" class="ds-field__label" :data-required="required || undefined">{{ label }}</span>
    <slot />
    <span v-if="error" class="ds-field__error">{{ error }}</span>
    <span v-else-if="helper" class="ds-field__helper">{{ helper }}</span>
  </label>
</template>

<script>
export default {
  name: 'DsField',
  props: {
    label: { type: String, default: '' },
    required: { type: Boolean, default: false },
    helper: { type: String, default: '' },
    /** Mensaje de error — reemplaza al helper cuando está presente. */
    error: { type: String, default: '' },
  },
};
</script>

<style scoped lang="scss">
.ds-field {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}
.ds-field__label {
  font-family: var(--font-sans);
  font-size: var(--text-body-s-size);
  font-weight: 500;
  color: var(--text-default);
  line-height: 1.4;
}
.ds-field__label[data-required]::after {
  content: " *";
  color: var(--text-error);
  font-weight: 400;
}
.ds-field__helper {
  font-family: var(--font-sans);
  font-size: var(--text-caption-size);
  font-weight: 400;
  color: var(--text-muted);
  line-height: 1.4;
}
.ds-field__error {
  font-family: var(--font-sans);
  font-size: var(--text-caption-size);
  font-weight: 400;
  color: var(--text-error);
  line-height: 1.4;
}
</style>
